import React, { useEffect, useMemo, useState } from "react";
import { api } from "../utils/api";
import MealCard from "../components/MealCard";
import { useI18n } from "../context/I18nContext";

export default function Desserts({ navigate }) {
  const { t, language } = useI18n();
  const [desserts, setDesserts] = useState([]);
  const [dessertTypes, setDessertTypes] = useState([]);
  const [cuisines, setCuisines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [dessertType, setDessertType] = useState("all");
  const [cuisine, setCuisine] = useState("all");
  const [search, setSearch] = useState("");

  const categories = useMemo(() => [
    { value: "all", label: t("all") },
    { value: "healthy", label: t("fitHealthy") },
    { value: "tasty", label: t("tasty") },
    { value: "balanced", label: t("balanced") },
  ], [t]);

  useEffect(() => {
    api.getDessertTypes().then((response) => setDessertTypes(response.data)).catch(console.error);
    api.getCuisines().then((response) => setCuisines(response.data)).catch(console.error);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(true);
      api.getMeals({ mealType: "dessert", category, dessertType, cuisine, search, lang: language })
        .then((response) => setDesserts(response.data))
        .catch(console.error)
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(timer);
  }, [category, dessertType, cuisine, search, language]);

  return (
    <div>
      <div className="page-header">
        <h1>🍰 {t("desserts")}</h1>
        <p>{t("dessertsIntro")}</p>
      </div>

      <div className="filter-bar filter-panel">
        <div className="search-box">
          <span>🔍</span>
          <input
            type="text"
            placeholder={t("searchDesserts")}
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          {search && <button onClick={() => setSearch("")}>×</button>}
        </div>

        <div className="filter-row">
          <span className="filter-label">{t("category")}</span>
          <div className="filter-options">
            {categories.map((item) => (
              <button key={item.value} className={`filter-btn ${category === item.value ? "active" : ""}`} onClick={() => setCategory(item.value)}>
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-row">
          <span className="filter-label">{t("dessertType")}</span>
          <select value={dessertType} onChange={(event) => setDessertType(event.target.value)} className="select-input">
            <option value="all">{t("allDessertTypes")}</option>
            {dessertTypes.map((item) => (
              <option key={item.value} value={item.value}>{item.value} ({item.count})</option>
            ))}
          </select>
        </div>

        <div className="filter-row">
          <span className="filter-label">{t("cuisine")}</span>
          <select value={cuisine} onChange={(event) => setCuisine(event.target.value)} className="select-input">
            <option value="all">{t("allCuisines")}</option>
            {cuisines.map((item) => (
              <option key={item.name} value={item.name}>{item.name}</option>
            ))}
          </select>
        </div>
      </div>

      {loading ? (
        <div className="loading"><div className="spinner" /><p>{t("loadingDesserts")}</p></div>
      ) : desserts.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🍰</div>
          <h3>{t("noDessertFound")}</h3>
          <p>{t("tryDifferentFilters")}</p>
        </div>
      ) : (
        <>
          <p className="result-count">{desserts.length} {t("dessertsFound")}</p>
          <div className="meals-grid">
            {desserts.map((meal, index) => (
              <MealCard
                key={meal.id}
                meal={meal}
                showDessertType
                onClick={() => navigate("detail", meal)}
                style={{ animationDelay: `${index * 25}ms` }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
